// WebGL capability + in-app-browser detection.
//
// The 360° viewer needs a working WebGL context. Without one, PlayCanvas
// throws a low-level "WebGL not supported" deep inside graphics-device
// creation (see playcanvas/createApp.ts). main.ts used to catch that and show
// a generic "Erro ao iniciar — recarregue a página", which is misleading:
// reloading can't conjure WebGL. We detect the condition up front and surface
// an accurate, actionable message instead.
//
// The common real-world trigger is an in-app browser (Instagram / LinkedIn /
// Facebook / etc.) — these embedded webviews frequently ship with WebGL
// disabled, and tour links are shared straight into those feeds.

/** True when the browser can create a WebGL (1 or 2) rendering context. */
export function isWebGLAvailable(): boolean {
  try {
    const canvas = document.createElement('canvas');
    const gl =
      canvas.getContext('webgl2') ||
      canvas.getContext('webgl') ||
      canvas.getContext('experimental-webgl');
    return gl != null;
  } catch {
    // Some locked-down webviews throw rather than return null.
    return false;
  }
}

/**
 * Heuristic: are we running inside a social/app in-app webview? These are the
 * usual no-WebGL culprits, and the remediation ("open in your real browser")
 * differs from a genuinely outdated desktop browser. UA is injectable for
 * testing.
 */
export function isInAppBrowser(ua: string = navigator.userAgent || ''): boolean {
  return /\b(FBAN|FBAV|FB_IAB|FBIOS|Instagram|LinkedInApp|Line|Twitter|Pinterest|Snapchat|MicroMessenger|TikTok|musical_ly)\b/i.test(
    ua,
  );
}
